export default {
  allSubscriptions: [],
  subscription: null,
  subscriptionTemporal: null,
  subscriptionsOverlay: false,
  menus: [],
  menuOptions: [],
  tags: [],
  ingredients: [],
  platesOptions: [],
  menuItems: [],
  currentMenu: null,
  currentMenuOption: null,
  currentDay: null,
  includeProteins: [
    "pollo",
    "res",
    "cerdo",
    "pescado",
    "vegano",
    "mexicana",
    "italiana",
    "americana",
    "oriental",
    "colombiana",
    "arabe",
    "parrilla",
  ],
  foodRestrictions: [
    "soya",
    "lacteos",
    "mariscos",
    "nueces",
    "huevos",
    "azucar",
    "picante",
    "condimentado",
    "cilantro",
    "pimenton",
    "cebolla",
  ],
  allMenuItemProducts: [],
  subscriptionDetails: [],
  carouselKey: 0,
  menuDetails: [],
  selectedFirstDay: null,
  dashboardSelectedTabIndex: null,
  menuPrices: null,
  dishToReplace: null,
  ingredientToReplace: null,
};
